import { DocumentoField } from '@components/Fields/DocumentoField';
import { StringField } from '@components/Fields/StringField';
import { TelefoneField } from '@components/Fields/TelefoneField';
import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { IForm } from '@hooks/useForm';
import { IVendedorEditar } from '@services/VendedorService';
import React from 'react';

export type VendedorEditarFormProps = {
    form: IForm<IVendedorEditar>
}

export function VendedorEditarForm ({ form }: VendedorEditarFormProps) {
    const { fields } = form;

    return (
        <HorizontalGrid>
            <GridItem xs={12}>
                <StringField 
                    field={fields.nome}
                    label="Nome"
                />
            </GridItem>

            <GridItem xs={6}>
                <DocumentoField 
                    maskType="cpf"
                    field={fields.cpf}
                    label="CPF"
                />
            </GridItem>

            <GridItem xs={6}>
                <TelefoneField
                    maskType="cel" 
                    field={fields.telefone}
                    label="Telefone"
                />
            </GridItem>
        </HorizontalGrid>
    )
}